module.exports = __webpack_public_path__ + "img/reward.3f46a7ee.svg";